module.exports = __webpack_public_path__ + "static/media/serviceProviderimg2.31900bd7.png";